import { Stack } from '@mui/material';
import { map } from 'lodash';
import { useMemo } from 'react';

import { useSubscriptionsInfo } from '@/api/subscriptions';
import { AlertChip } from '@/components/AlertChip';
import { PaymentTroubleAlert } from '@/components/subscriptions/PaymentTroubleAlert';
import { SummaryCard, SummaryCardBody, SummaryCardButton } from '@/components/ui/SummaryCard';
import { errorMessage } from '@/utils';

export const SubscriptionStatusCard = () => {
    const { data: subscriptionInfo, isPending, isError, error } = useSubscriptionsInfo();

    const statusLabel = useMemo(() => {
        const statuses = new Set(map(subscriptionInfo?.data, 'status'));

        if (statuses.has('active') || statuses.has('incomplete') || statuses.has('trialing')) {
            return 'Active';
        }
        if (statuses.has('past_due')) {
            return 'Past due';
        }
        return 'Inactive';
    }, [subscriptionInfo?.data]);

    return (
        <SummaryCard title="Automatic recurring subscription" isLoading={isPending}>
            <SummaryCardBody>
                {isError ? (
                    <AlertChip severity="error" label={errorMessage(error, 'Unable to load subscription status')} />
                ) : (
                    <Stack direction="row" sx={{ alignItems: 'center', gap: 1 }}>
                        {statusLabel}
                        <PaymentTroubleAlert variant="chip" />
                    </Stack>
                )}
            </SummaryCardBody>
            <SummaryCardButton href="/payment">Manage settings</SummaryCardButton>
        </SummaryCard>
    );
};
